import React, { useContext, useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import "../../plans-style.scss";
import ReviewSlider from "./review-slider";
import WorkSimpliSuite from "./worksimpli-suite";
import OrchestrationServiceAPI from "../../Services/OrchestrationService";
import UserDataContext from "../../Contexts/User.context";
import ButtonComponent from "../../Components/Shared/ButtonComponent";
import { useNavigate, useParams } from "react-router-dom";
import { APP_NAVIGATION } from "../../Util/Constants";
import PathHelper from "../../Util/PathHelper";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import FormDataContext from "../../Contexts/FormData.context";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import axios, { AxiosRequestConfig } from "axios";
import { getTemplateHtml } from "../../Services/TemplateServices";
import { DOCUMENT_PAPER_TYPE, templateActionEnum } from "../../Config/Constants";
import { logger } from "../../Middleware/Logger";
import ErrorMessage from "../../Util/ErrorMessage";
import Template from "../../Components/Template/Template";
import TrustPilotReview from "../../Components/Shared/TrustPilotReview";
import { getLogoImagePath } from "../../Util/general-config";

type Props = {};

const Plans = (props: Props) => {
  const { state } = useContext(UserDataContext);
  const [activeSku, setActive] = useState("");
  const [planLists, setPlans] = useState<any>([]);
  const [limitedAccessPlan, setLimitedAccessPlan] = useState<any>([]);
  const [fullAccessPlan, setFullAccessPlan] = useState<any>([]);
  const [annualAccessPlan, setAnnualAccessPlan] = useState<any>([]);
  const [limitedAccessUnitPrice, setLimitedAccessUnitPrice] = useState<any>([]);
  const [fullAccessUnitPrice, setFullAccessUnitPrice] = useState<any>([]);
  const [annualAccessUnitPrice, setAnnualAccessUnitPrice] = useState<any>([]);
  const [limitedAccessRecurringPrice, setLimitedAccessRecurringPrice] = useState<any>([]);
  const [fullAccessRecurringPrice, setFullAccessRecurringPrice] = useState<any>([]);
  const [annualAccessRecurringPrice, setAnnualAccessRecurringPrice] = useState<any>([]);
  const [showLoader, setShowLoader] = useState("d-none");
  const formData = useContext(FormDataContext);
  const docId: string = formData.state?.docId as string;
  const { template } = useParams();
  const { state: templateState, dispatch } = useContext(TemplateDataContext);
  const { templates, templatePath, selectedState, activeTemplateHtml, isLoading } = templateState;
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [svgData, setSvgData] = useState<string[]>([]);
  const navigate = useNavigate();
  let pathRedirect = PathHelper(APP_NAVIGATION.PLAN);
  const planChangeHandler = (_index: any) => {
    if (!!planLists[_index]) {
      if (activeSku === planLists[_index].id) {
        checkoutPage();
      } else {
        setActive(planLists[_index].id);
      }
    }
  };
  const checkoutPage = () => {
    navigate(pathRedirect.next + "?s=" + activeSku);
  };
  useEffect(() => {
    const { userGUID } = state;
    if (userGUID) {
      setShowLoader("d-block");
      const data = {
        planType: "_default",
        currencyCD: "",
        countryCD: "",
        device: null,
        locale: "en",
      };
      const plansResponse = OrchestrationServiceAPI.getUserPlan(userGUID, data)
        .then((items: any) => {
          if (!!items) {
            setPlans(items);
            setLimitedAccessPlan(items[0]);
            setLimitedAccessUnitPrice(items[0].currencySymbol + items[0].unitPrice);
            setLimitedAccessRecurringPrice(items[0].currencySymbol + items[0].recurringPrice);
            setFullAccessPlan(items[1]);
            setFullAccessUnitPrice(items[1].currencySymbol + items[1].unitPrice);
            setFullAccessRecurringPrice(items[1].currencySymbol + items[1].recurringPrice);
            setAnnualAccessPlan(items[2]);
            setAnnualAccessUnitPrice(items[2].currencySymbol + items[2].unitPrice);
            setAnnualAccessRecurringPrice(items[2].currencySymbol + items[2].recurringPrice);
            setActive(items[1].id);
          }
          setShowLoader("d-none");
        })
        .catch((error) => {
          setShowLoader("d-none");
        });
    } else {
      setShowLoader("d-none");
      //navigate(!!locale ? setLocaleURL(ROUTE_CONSTANT.HOME_LOCALE, locale) : ROUTE_CONSTANT.HOME);
    }
  }, []);
  const loadPaperTypeContent = async ({ html, paperType }: { html?: string; paperType: string }) => {
    dispatch({ type: templateActionEnum.SET_IS_LOADING, payload: true });
    const paperSize = paperType;
    const getHtmlData: any = document.getElementById("getHtml");

    try {
      const formData = new FormData();
      formData.append("html", getHtmlData?.innerHTML);
      formData.append("paperSize", paperSize);

      //   htmlToSvg(formData, setSvgData, dispatch);
    } catch (error) {
      if (!axios.isCancel(error)) {
        logger.error("🚀 ~ file: useEffect.tsx ~ line 47 ~ changeLayout ~ error", error);
        dispatch({
          type: templateActionEnum.SET_ERROR,
          payload: { show: true, message: ErrorMessage.TEMPLATE_HTML_FAILED },
        });
      }
      dispatch({ type: templateActionEnum.SET_IS_LOADING, payload: false });
    }
  };
  const getTemplate = async (config: AxiosRequestConfig) => {
    if (template !== undefined && templates[template] !== undefined && templates[template].title !== undefined) {
      setTitle(templates[template].title);
      return;
    }
    const { data: html } = await getTemplateHtml({
      endPoint: templatePath,
      templateKey: activeTemplateHtml || "",
      config,
      state: selectedState,
    });
    if (html) {
      await loadPaperTypeContent({ html, paperType: DOCUMENT_PAPER_TYPE[0].val });
      setHtmlContent(html);
    }
    /* select the title from loaded templated */
    const matchingTitle = document.querySelector(".thumb-title");
    if (matchingTitle && matchingTitle.textContent) {
      setTitle(matchingTitle.textContent.trim());
    } else {
      /* if title is not empty then fetch from template */
      /* replace all the '\r\n'  */
      /* match the div with class 'thumb-title' and get the title  */
      const matching: string[] | null = html
        .replaceAll("\r\n", "")
        .match(/<div\sclass="[^"]*?thumb-title[^"]*?"[\r\n]?.*?>(.*?)<\/div>/);

      if (matching) {
        matching.forEach((element: string, index: number) => {
          if (index === 1) setTitle(element);
        });
      }
    }
  };
  useEffect(() => {
    if (docId) {
      const cancelToken = axios.CancelToken.source();
      const config = { cancelToken: cancelToken.token };
      try {
        getTemplate(config);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.log("error", error);
        }
      }
    }
  }, [docId]);
  return (
    <>
      <style>
        {`
            .olark-button-focus-wrapper {
              display: none;
            }
          `}
      </style>
      <ReactLoader loaderProps={{ showloader: showLoader }} />
      <div className="container plans">
        {/* <h1 className="main-header">Select a Plan to Access Your Download!</h1> */}
        <h1 className="main-header pb-2 pt-4">Ready To Download Your Legal Document!</h1>
        <h4>Choose the plan that best suits your needs:</h4>
        <div className="row">
          <div className="col-lg-6">
            <div className="main-thumbnail">
              <div className={docId ? "seThumbnail isFormTemp" : "seThumbnail"}>
                {docId ? (
                  <>
                    {" "}
                    {activeTemplateHtml && htmlContent && isLoading && (
                      <Template
                        svgData={svgData}
                        templateKey={activeTemplateHtml}
                        htmlContent={htmlContent}
                        isInnerPage
                      />
                    )}
                  </>
                ) : (
                  <>
                    {" "}
                    <img className="img-fluid" src={getLogoImagePath()} alt="LEGALSimpli" />
                  </>
                )}
              </div>
            </div>
            <div className="trustpilotWrap d-block ">
              <TrustPilotReview />
            </div>
          </div>
          {/* <div className="col-lg-6 p-20"> */}
          <div className="col-md-12 col-lg-6 ">
            <div className="col-12 fbn bounce-effect pricing-mobile-btn">
              <ButtonComponent
                buttonProps={{
                  text: "Create Document",
                  id: "next",
                  icon: <i className="fa-solid fa-circle-arrow-right"></i>,
                  className: "btn btn-lg theme-btn-primary alante",
                }}
                clickHandler={checkoutPage}
              />
            </div>

            <div className="tabs-group">
              <Tab.Container id="left-tabs-example" defaultActiveKey="second">
                <Row>
                  <Col sm={12}>
                    <Nav variant="pills" className="flex-column tabs-list">
                      <Nav.Item className="" onDoubleClick={checkoutPage} onClick={() => planChangeHandler(0)}>
                        <Nav.Link eventKey="first" className="">
                          <i className="fa-solid fa-circle-check"></i>
                          <span className="en">14-DAY LIMITED ACCESS</span>
                          <span className="tabs-price ml-auto">{limitedAccessUnitPrice}</span>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second" onDoubleClick={checkoutPage} onClick={() => planChangeHandler(1)}>
                          <i className="fa-solid fa-circle-check"></i>
                          <span className="en">14-DAY FULL ACCESS</span>
                          <span className="tabs-price ml-auto">{fullAccessUnitPrice}</span>
                          <div className="ob2">
                            <span className="most-popular">Most Popular</span>
                          </div>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third" onDoubleClick={checkoutPage} onClick={() => planChangeHandler(2)}>
                          <i className="fa-solid fa-circle-check"></i>
                          <span className="en">Annual Plan</span>
                          <span className="tabs-price ml-auto price-annual">
                            {annualAccessUnitPrice}
                            <span className="text-month">/month</span>
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <div className="panel-body">
                          <h5 className="payment-includes">Includes</h5>
                          <ul>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon1.svg"}
                                  alt="create"
                                  width={20}
                                />
                              </span>
                              Create and customize legal documents without hiring an attorney
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon3.svg"}
                                  alt="choose"
                                  width={17}
                                />
                              </span>
                              Choose from 100+ legal forms and templates
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon2.svg"}
                                  alt="pre written"
                                  width={17}
                                />
                              </span>
                              Pre-written legal samples
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/File.svg?v=20230807062706"
                                  }
                                  alt="Unlimited Downloads"
                                />
                              </span>
                              Unlimited downloads and edits
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                {" "}
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/pdf-icon.svg?v=20230807062708"
                                  }
                                  alt="Convert to Any Format "
                                />
                              </span>
                              Convert and save to any format (word, docx, pdf, jpeg, excel)
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/File.svg?v=20230807062706"
                                  }
                                  alt="Unlimited Downloads"
                                />
                              </span>
                              Print, download & share your legal documents
                            </li>
                          </ul>
                          <p
                            id="authContentPlaceHolder_monthlydescription"
                            className="text-center  border-top pb-2 pt-4"
                          >
                            After 14 days, auto-renews {limitedAccessRecurringPrice} billed every 4 weeks. You may
                            cancel anytime
                          </p>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <div className="panel-body">
                          <h5 className="payment-includes">Includes</h5>
                          <ul>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon1.svg"}
                                  alt="Unlimited Edits"
                                  width={20}
                                />
                              </span>
                              Create and customize legal documents without hiring an attorney
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon3.svg"}
                                  alt="Unlimited Edits"
                                  width={17}
                                />
                              </span>
                              Choose from 100+ legal forms and templates
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon2.svg"}
                                  alt="Unlimited Edits"
                                  width={17}
                                />
                              </span>
                              Pre-written legal samples
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/File.svg?v=20230807062706"
                                  }
                                  alt="Unlimited Downloads"
                                />
                              </span>
                              Unlimited downloads and edits
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/pdf-icon.svg?v=20230807062708"
                                  }
                                  alt="Convert to Any Format "
                                />
                              </span>
                              Convert and save to any format
                              <div>(word, .docx, .doc, jpg, excel)</div>
                            </li>

                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/Users-new.svg?v=20230807062708"
                                  }
                                  alt="Share with 5 Family Members &amp; Friends"
                                />
                              </span>
                              <span id="monthly5userText">Share with 5 Family Members &amp; Friends</span>
                            </li>
                            <li className="EngLanguage">
                              <span className="sell-page-icons">
                                <img
                                  src={
                                    `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                    "/content/assets/images/File.svg?v=20230807062706"
                                  }
                                  alt="Unlimited Downloads"
                                />
                              </span>
                              Print, download & share your legal documents
                            </li>
                          </ul>
                          <p
                            id="authContentPlaceHolder_monthlyLimiteddescription"
                            className="text-center border-top pb-2 pt-4"
                          >
                            After 14 days, auto-renews {fullAccessRecurringPrice} billed every 4 weeks. You may cancel
                            anytime
                          </p>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <div className="panel-body">
                          <h5 className="payment-includes">Includes</h5>
                          <ul>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon1.svg"}
                                  alt="Unlimited Edits"
                                  width={20}
                                />
                              </span>
                              Create and customize legal documents without hiring an attorney
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon3.svg"}
                                  alt="Unlimited Edits"
                                  width={17}
                                />
                              </span>
                              Choose from 100+ legal forms and templates
                            </li>
                            <li>
                              <span className="sell-page-icons">
                                <img
                                  src={process.env.PUBLIC_URL + "/static/images/temp-icon2.svg"}
                                  alt="Unlimited Edits"
                                  width={17}
                                />
                              </span>
                              Pre-written legal samples
                            </li>
                            <li>
                              <img
                                className="sell-page-icons"
                                src={
                                  `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                  "/content/assets/images/File.svg?v=20230807062706"
                                }
                                alt="PDFSimpli"
                              />
                              Unlimited downloads and edits
                            </li>
                            <li>
                              <img
                                className="sell-page-icons"
                                src={
                                  `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                  "/content/assets/images/pdf-icon.svg?v=20230807062708"
                                }
                                alt="PDFSimpli"
                              />
                              Convert and save to any format
                              <br />
                              (word, .docx, .doc, jpg, excel)
                            </li>
                            <li>
                              <img
                                className="sell-page-icons"
                                src={
                                  `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                  "/content/assets/images/Sign-new.svg?v=20230807062708"
                                }
                                alt="PDFSimpli"
                              />
                              Add and request electronic signatures in seconds
                            </li>
                            <li>
                              <img
                                className="sell-page-icons"
                                src={
                                  `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                  "/content/assets/images/Users-new.svg?v=20230807062708"
                                }
                                alt="PDFSimpli"
                              />
                              <span id="sm_mnthlyPlan">Share with 7 Other Users</span>
                            </li>
                            <li className="EngLanguage">
                              <img
                                className="sell-page-icons"
                                src={
                                  `${process.env.REACT_APP_BLOB_HOST_URL}` +
                                  "/content/assets/images/File.svg?v=20230807062706"
                                }
                                alt="PDFSimpli"
                              />
                              Print, download & share your legal documents
                            </li>
                          </ul>
                          <p id="authContentPlaceHolder_yearlyPlanBottomText" className="text-center">
                            Initial charge of {annualAccessRecurringPrice}. After 1 year, auto-renews{" "}
                            {annualAccessRecurringPrice} billed every year. You may cancel anytime.
                          </p>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                    <div className="nplan-footer_box text-center">
                      <p className="nplan-footer">
                        <strong>30-day money back guarantee. </strong>You may cancel by{" "}
                        <a href="mailto:support@legalsimpli.com" style={{ color: "#007bff" }}>
                          email
                        </a>
                        , by chat or by calling us toll-free at <strong>+1-855-235-3175</strong>
                        <br />
                      </p>
                      {/* <p className="text-center guarantee ">
                                                To access your first document for free after a 24 hour delay please click{' '}
                                                <strong>
                                                    <a style={{ color: '#007bff' }} id="delaySendFile" href="javascript:void(0)">
                                                        here
                                                    </a>
                                                </strong>
                                                <br />
                                            </p> */}
                      <p></p>
                    </div>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>

      <ReviewSlider />
      <WorkSimpliSuite />
    </>
  );
};
export default Plans;
